import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ResponsiveComponent from '@components/form/ResponsiveComponent';
import {SimpleDialog} from '@components/form/SimpleDialog';
import {StandartInput} from '@components/form/StandartInput';
import {LabelButton} from "@components/common/buttons/LabelButton";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
const merge = require('deepmerge');
import Typography from "@material-ui/core/Typography";
import RemoteAutocompleteSelect from "@components/form/RemoteAutocompleteSelect";

export class NewDocumentComponent extends React.Component {
    initState = {
        form: {
            template_id: null,
            template: null
        },
        errors: {}
    };

    state = {
        open: false,
        ...this.initState
    };

    selectTemplate = async (templateId) => {
        let response = await this.props.getDocsTemplateDetails(templateId);

        if (response.data) {
            this.setState({...this.state, form: {
                template_id: templateId,
                template: {...response.data, field: response.data.value}
            }})
        }
    };

    createDocument = async () => {
        let response = await this.props.createOrderDocument(
            this.props.orderId,
            this.state.form.template_id,
            this.state.form.template
        );

        if (response.errors && Object.keys(response.errors).length) {
            this.setState({...this.state, errors: response.errors});
        } else {
            if (response.data) {
                this.setState({open: false});
                if (this.props.onSubmitRedirect) {
                    this.props.onSubmitRedirect(response.data);
                }
            }
        }
    };

    variableFormRender = (variable, index) => {
        const { classes } = this.props;

        const changeValue = (value, index) => {
            let { fields } = this.state.form.template;

            fields[index].value = value;
            this.setState({
                ...this.state,
                form: {...this.state.form, template: {
                    ...this.state.form.template,
                    fields: fields
                }}
            });
        }

        const valueInput = (index) => <StandartInput
            name={'value'}
            className={classes.input}
            variant="outlined"
            margin={'none'}
            fullWidth
            value={this.state.form.template.fields[index].value}
            errors={this.state.errors}
            label={'Значение'}
            onChange={({target: {value}}) => changeValue(value, index)}
            multiline
            rows={3}
        />

        return (<div className={classes.variable_row}>
            <div className={classes.variable_row_info}>
                <Typography variant={'body2'}>{variable.description}</Typography>
                <Typography variant={'caption'}>{variable.title}</Typography>
            </div>
            <div className={classes.variable_row_input}>
                {valueInput(index)}
            </div>
        </div>);
    }

    render() {
        let { classes } = this.props;

        return <SimpleDialog
            open={this.state.open}
            fullWidth={true}
            maxWidth={'md'}
            onClose={(e) => this.setState({open: false})}
            title={<ResponsiveComponent xs='Добавление шаблона' sm='Добавление документа к заказу'/>}
            icon={<LabelButton
                title={'Добавить документ'}
                icon={<AddCircleRoundedIcon color={'primary'}/>}
                onClick={(e) => this.setState({open: true})}
            />}
            actions={[
                (<Button
                    onClick={(e) => this.createDocument()}
                    color="primary"
                    variant="contained"
                >
                    Сохранить
                </Button>),
            ]}
        >
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12}>
                    <RemoteAutocompleteSelect
                        url={'/api/v1/autocomplete/document-templates'}
                        name={'template_id'}
                        className={classes.input}
                        variant="outlined"
                        margin={'none'}
                        value={this.state.form.template_id}
                        errors={this.state.errors}
                        onChange={(e, {value}) => this.selectTemplate(value)}
                        disableClearable={true}
                        fillFirst={true}
                        size={'small'}
                        fullWidth
                    />

                    <div className={classes.variables}>
                        {this.state.form.template?.fields.map((field, index) => <React.Fragment key={`variable_${index}`}>
                            {this.variableFormRender(field, index)}
                        </React.Fragment>) || null}
                    </div>
                </Grid>
            </Grid>
        </SimpleDialog>
    }
}
